export const FETCH_REPORT_SECTION_FILTERS_START = 'FETCH_REPORT_SECTION_FILTERS_START';
export const FETCH_REPORT_SECTION_FILTERS_SUCCESS = 'FETCH_REPORT_SECTION_FILTERS_SUCCESS';

export const FETCH_REPORT_SECTIONS_START = 'FETCH_REPORT_SECTIONS_START';
export const FETCH_REPORT_SECTIONS_SUCCESS = 'FETCH_REPORT_SECTIONS_SUCCESS';

export const FETCH_REPORT_START = 'FETCH_REPORT_START';
export const FETCH_REPORT_SUCCESS = 'FETCH_REPORT_SUCCESS';
export const FETCH_REPORT_FAIL = 'FETCH_REPORT_FAIL';
